// theirs
import classNames from 'classnames'

// ours
import { ContentDataModel } from '../../../interfaces'
import { callToActionBaseClass, StyledCallToAction } from './style'

export interface CallToActionProps {
    className?: string
    testId?: string
    content: ContentDataModel
    animationControls?: any
}

const CallToAction = ({ className, testId, content }: CallToActionProps) => {
    return (
        <StyledCallToAction
            className={classNames(callToActionBaseClass, className)}
            data-testid={testId}
            content={content}
        >
            <div className="content-top">
                <div className={`${callToActionBaseClass}-zoom-image`}></div>
            </div>
            <div className="content-left">
                <div className="content-outer">
                    <div className="content-inner">
                        {content.contentTitle && (
                            <div className="title-wrapper">
                                <h2>{content.contentTitle}</h2>
                            </div>
                        )}
                        {content.contentText && (
                            <div className="text-wrapper">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: content.contentText,
                                    }}
                                />
                            </div>
                        )}
                        {content.contentCallToActionText &&
                            content.contentCallToActionHref && (
                                <div className="call-to-action-wrapper">
                                    <a
                                        className="call-to-action"
                                        href={content.contentCallToActionHref}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {content.contentCallToActionText}
                                    </a>
                                </div>
                            )}
                    </div>
                </div>
            </div>
            <div className="content-middle">
                <div className="content-outer">
                    <div className="content-inner">
                        {content.contentSecondTitle && (
                            <div className="title-wrapper">
                                <h2>{content.contentSecondTitle}</h2>
                            </div>
                        )}
                        {content.contentSecondText && (
                            <div className="text-wrapper">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: content.contentSecondText,
                                    }}
                                />
                            </div>
                        )}
                        {content.contentSecondCallToActionText &&
                            content.contentSecondCallToActionHref && (
                                <div className="call-to-action-wrapper">
                                    <a
                                        className="call-to-action"
                                        href={
                                            content.contentSecondCallToActionHref
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {content.contentSecondCallToActionText}
                                    </a>
                                </div>
                            )}
                    </div>
                </div>
            </div>
            <div className="content-right">
                <div className="content-outer">
                    <div className="content-inner">
                        {content.contentThirdTitle && (
                            <div className="title-wrapper">
                                <h2>{content.contentThirdTitle}</h2>
                            </div>
                        )}
                        {content.contentThirdText && (
                            <div className="text-wrapper">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: content.contentThirdText,
                                    }}
                                />
                            </div>
                        )}
                        {content.contentThirdCallToActionText &&
                            content.contentThirdCallToActionHref && (
                                <div className="call-to-action-wrapper">
                                    <a
                                        className="call-to-action"
                                        href={
                                            content.contentThirdCallToActionHref
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {content.contentThirdCallToActionText}
                                    </a>
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </StyledCallToAction>
    )
}

export default CallToAction
